import { Injectable } from '@angular/core';
import { UrlTree, Router } from '@angular/router';
import { NbAuthService } from '@nebular/auth';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { SeguridadService, infoAuditoria } from 'src/app/services/seguridad.service';

@Injectable({
  providedIn: 'root'
})
export class ToPerfilGuard  {

  auditoria?: infoAuditoria;

  constructor(private authService: NbAuthService, private router: Router,
    private seguridadService: SeguridadService) { }

  canActivate(): Observable<boolean | UrlTree> {
    return this.authService.getToken().pipe(
      map(token => {
        const payload = token.getPayload();
        if (payload.iIDEntidad && payload.iIDPerfil) {
          this.auditoria = {
            tFormulario: '~/auth/loginDav',
            tDescripcion: "El usuario " + token.getPayload().name + " ha iniciado sesión"
          };
          this.seguridadService.setAuditoria(this.auditoria).subscribe();
          return true;
        } else {
          return this.router.parseUrl('/auth/perfil');
        }
      })
    );
  }
}
